import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { CACHE_BREAKER_ENDPOINTS, InterceptorEndpoints } from '@core/const';
import { Observable } from 'rxjs';
import { InterceptorEndpointService } from '../services/interceptor-endpoints.service';

@Injectable({ providedIn: 'root' })
export class CacheBreakerInterceptor implements HttpInterceptor {
  constructor(
    private cacheBreakerEndpointService: InterceptorEndpointService,
    @Optional() @Inject(CACHE_BREAKER_ENDPOINTS) private endpoints?: InterceptorEndpoints[],
  ) {
    this.endpoints = this.endpoints ? this.endpoints : [];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.cacheBreakerEndpointService.requestIsIntercept(req, this.endpoints)) {
      const tokenizedReq = req.clone({
        params: req.params.set('cachebreaker', btoa(`${Math.random()}`)),
      });

      return next.handle(tokenizedReq);
    }

    return next.handle(req);
  }
}
